// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-suggestion {\n  height: -webkit-min-content;\n  height: -moz-min-content;\n  height: min-content;\n}", ""]);
// Exports
module.exports = exports;
